import React from 'react'
import styled from 'styled-components'
import { Button, Colors, Modal, Display2 } from 'advenio-components'
import { Form } from 'formsy-react'
import PropTypes from 'prop-types'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
`
const Text = styled(Display2)`
  color: ${Colors.gray700};
  margin-bottom: 16px;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 32px;
`

const ConfirmModal = ({ title, message, callback, isOpen, loading, onClose }) => (
  <Modal
    isOpened={isOpen}
    onClose={onClose}
    headerTitle={title}
  >
    <Container>
      <Form onSubmit={callback}>
        <Text>{message}</Text>
        <ButtonContainer>
          <Button onClick={onClose}>Cancelar</Button>
          <Button primary loading={loading} type="submit">
            Aceptar
          </Button>
        </ButtonContainer>
      </Form>
    </Container>
  </Modal>
)

ConfirmModal.propTypes = {
  /** Title of the modal */
  title: PropTypes.string.isRequired,
  /** The question the user have to confirm */
  message: PropTypes.string.isRequired,
  /** Callback function to be fired when submitting the form */
  callback: PropTypes.func.isRequired,
  /** Indicates if the modal should be open or not */
  isOpen: PropTypes.bool,
  /** Indicates if the action is in the process of being executed */
  loading: PropTypes.bool.isRequired,
  /** Callback function to be fired when closing the modal */
  onClose: PropTypes.func.isRequired,
}

ConfirmModal.defaultProps = {
  isOpen: false,
}

export default ConfirmModal



// WEBPACK FOOTER //
// ./src/Components/ConfirmModal.jsx